import { TFunction } from 'react-i18next'
import { FiscalType } from 'src/api/api.generated'

export function displayFiscalType(t: TFunction<'translation', undefined>, fiscalType?: FiscalType | null): string {
  if (fiscalType) {
    const key = `commons.fiscal_type.${fiscalType.toLowerCase()}`
    return t(key as any)
  }
  return ''
}
